(() => {
  if (window.ffProductVariantKeyboardReady) return;
  window.ffProductVariantKeyboardReady = true;

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest('variant-selects input[type="radio"]');
    if (!input) return;

    const supportedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    if (!supportedKeys.includes(event.key)) return;

    const fieldset = input.closest('fieldset');
    if (!fieldset) return;

    const options = [...fieldset.querySelectorAll('input[type="radio"]')].filter(
      (option) => !option.disabled && !option.classList.contains('disabled')
    );
    if (options.length < 2) return;

    const currentIndex = Math.max(0, options.indexOf(input));
    let nextIndex = currentIndex;

    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = options.length - 1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % options.length;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + options.length) % options.length;

    const nextOption = options[nextIndex];
    if (!nextOption || nextOption === input) return;

    event.preventDefault();
    nextOption.checked = true;
    nextOption.focus();
    nextOption.dispatchEvent(new Event('input', { bubbles: true }));
    nextOption.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
